export default {"src":"/_next/static/media/skillz_logo_black.78a6ce22.svg","height":21,"width":82,"blurWidth":0,"blurHeight":0};